import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { useAccessControlCheck } from './useAccessControlCheck';
import { IAccessControlCheckProps } from '../IAccessControlCheckProps';

export const useHasPermissions = (allowedPermissions: ePermissions[], requireAll?: boolean) => {
  return useAccessControlCheck([{ allowedPermissions, requireAll }])[0];
};

export const useHasManyPermissions = (values: IAccessControlCheckProps[]) => {
  return useAccessControlCheck(values);
};
